// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isOnBoardTemplate = function (this: any) {
  return this.model.isOnBoardTemplate();
};
export { isOnBoardTemplate };
